import { Section } from '@Config/section';
import { DataManagement } from '@Helper/DataManagement';
import { ICTask, ProjectPlaybook, ProjectTemplate } from '@Helper/Interfaces';
import { RootState } from '@Store/store';
import { FileItemProps } from '@components/Core/Folders/FileItem/FileItem.component';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseURL = process.env.REACT_APP_MERGEFLO_API_URL ?? '';
const Version = process.env.REACT_APP_MERGEFLO_API_VERSION ?? '';

export interface IProps {
  template: ProjectTemplate | null;
  playbook: ProjectPlaybook | null;
  tasks: ICTask[];
  sections: Section[];
  loading: boolean;
  files: FileItemProps[] | null;
  taskDetailHistory: ICTask[];
  isShowTaskModal: boolean;
}

const initialState: IProps = {
  template: null,
  playbook: null,
  tasks: [],
  sections: [],
  loading: true,
  files: null,
  taskDetailHistory: [],
  isShowTaskModal: false,
};

export const getProjectTemplateDetail = createAsyncThunk(
  'personalTemplatesDetail/getProjectTemplatedetail',
  async (initialID: string, { getState }) => {
    const dataManagement = new DataManagement();
    const response = await axios.get(
      BaseURL + Version + 'mergeflo/template/' + initialID + '/details',
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + dataManagement.getData('userToken'),
        },
      }
    );

    if (response.data) {
      return response.data;
    } else {
      return null;
    }
  }
);

export const personalTemplatesDetailSlice = createSlice({
  name: 'personalTemplatesDetail',
  initialState,
  reducers: {
    postProjectTemplateDetailSections: (
      state,
      action: PayloadAction<Section[]>
    ) => {
      state.sections = action.payload?.sort((a, b) =>
        a.sectionOrder! > b.sectionOrder! ? 1 : -1
      );
    },
    postProjectTemplateDetailTask: (state, action: PayloadAction<ICTask[]>) => {
      state.tasks = action.payload;
    },
    postProjectTemplate: (state, action: PayloadAction<FileItemProps[]>) => {
      state.files = action.payload;
    },
    postTaskHistory: (state, action: PayloadAction<ICTask>) => {
      state.taskDetailHistory.push(action.payload);
    },
    deleteTaskHistory: (state, action: PayloadAction<string>) => {
      state.taskDetailHistory = state.taskDetailHistory.filter(
        (item: ICTask) => item.id !== action.payload
      );
    },
    postTaskTray: (state, action: PayloadAction<ICTask[]>) => {
      state.taskDetailHistory = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getProjectTemplateDetail.pending, state => {
        state.loading = true;
      })
      .addCase(getProjectTemplateDetail.fulfilled, (state, action) => {
        if (action.payload) {
          state.playbook = action.payload.playbook;
          state.template = action.payload.template;
          state.sections = action.payload.sections;
          state.tasks = action.payload.tasks;
        }
        state.loading = false;
      });
  },
});

export const {
  postProjectTemplateDetailSections,
  postProjectTemplateDetailTask,
  postProjectTemplate,
  postTaskHistory,
  deleteTaskHistory,
  postTaskTray,
} = personalTemplatesDetailSlice.actions;

export const getPersonalTemplatesDetail = (state: RootState) =>
  state.personalTemplatesDetailReducer;

export default personalTemplatesDetailSlice.reducer;
